/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	FormGroup,
	Label,
	Button,
	Row,
	Col,
	Input,
} from 'reactstrap';
import WebapiCommon from '../../app/common/util/webapi.common';
import * as commonActions from '../../app/common/common.action';
import IntlMessage from '../../helpers/intlMessage';

export default function ModalCertificacao({
	onModal,
	onSuccess,
	isOpen,
	laudos,
	close,
	cancelar,
}) {
	const [modalAberto, setModalAberto] = useState(isOpen);
	const [pin, setPin] = useState('');
	const [cpf, setCpf] = useState('');

	const dispatch = useDispatch();

	function resetInputs() {
		setPin();
		setCpf();
	}

	function TestaCPF(strCPF) {
		let Soma = 0;
		let Resto;

		if (strCPF === '00000000000') return false;
		if (strCPF === '11111111111') return false;
		if (strCPF === '22222222222') return false;
		if (strCPF === '33333333333') return false;
		if (strCPF === '44444444444') return false;
		if (strCPF === '55555555555') return false;
		if (strCPF === '66666666666') return false;
		if (strCPF === '77777777777') return false;
		if (strCPF === '88888888888') return false;
		if (strCPF === '99999999999') return false;

		for (let i = 1; i <= 9; i++)
			Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
		Resto = (Soma * 10) % 11;

		if (Resto === 10 || Resto === 11) Resto = 0;
		if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

		Soma = 0;
		for (let i = 1; i <= 10; i++)
			Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
		Resto = (Soma * 10) % 11;

		if (Resto === 10 || Resto === 11) Resto = 0;
		if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
		return true;
	}

	function certificar() {
		const strCPF = cpf.replace('-', '').replaceAll('.', '');
		const isValidCPF = TestaCPF(strCPF);
		if (!isValidCPF) {
			return alert('CPF Inválido');
		}

		const currentLaudos = laudos.length === 0 ? null : laudos;
		const payload = {
			laudos: currentLaudos,
			cpf: strCPF,
			pin,
		};

		dispatch(commonActions.showFadeCarregando(true));

		if (!laudos || laudos.length === 0) {
			WebapiCommon.enviarCertificadosPendentes(payload).then((res) => {
				dispatch(
					commonActions.showAlerta('sucesso', res.resultMessage, 2000, `550px`)
				);
				onSuccess();
			});
		} else {
			WebapiCommon.enviarCertificadosPendentesSelecionados(payload).then(
				(res) => {
					dispatch(
						commonActions.showAlerta(
							'sucesso',
							res.resultMessage,
							2000,
							`550px`
						)
					);
					onSuccess();
				}
			);
		}
		dispatch(commonActions.showFadeCarregando(false));
		toggle();
	}

	useEffect(() => {
		resetInputs();
		setModalAberto(isOpen);
	}, [isOpen]);

	const toggle = () => {
		setModalAberto(!modalAberto);
		onModal(!modalAberto);
	};

	function validarCpf(val) {
		let _cpf = val;
		if (val.length === 11 && val.indexOf('.') < 0) {
			_cpf = _cpf
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d)/, '$1.$2')
				.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		} else if (val.length < 12) {
			_cpf = _cpf.replace(/(\d{3})(\d)/, '$1.$2');
		} else {
			_cpf = _cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
		}
		setCpf(_cpf);
	}

	function validarPin(val) {
		if (val.length > 6) {
			return;
		}
		setPin(val);
	}

	return (
		<Modal
			className="modal-confirm"
			centered
			isOpen={modalAberto}
			toggle={toggle}
		>
			<ModalHeader toggle={!close ? toggle : close}>
				<IntlMessage id = "dashboards.examDetails.submitCertification"/>
				{/* de sepultamento | especial */}
			</ModalHeader>
			<ModalBody>
				<strong><IntlMessage id = "dashboards.examDetails.reports"/></strong>{' '}
				{!laudos || laudos.length === 0 ? <IntlMessage id = "dashboards.reports.all"/> : JSON.stringify(laudos)}
				<hr />
				<Row>
					<Col>
						<FormGroup className="confirmar-primary">
							<Label><IntlMessage id = "dashboards.examDetails.cpf"/></Label>
							<Input
								type="text"
								value={cpf}
								maxLength="14"
								onChange={(e) => validarCpf(e.target.value)}
							/>
						</FormGroup>
					</Col>
					<Col>
						<FormGroup className="confirmar-primary">
							<Label><IntlMessage id = "dashboards.examDetails.pin"/></Label>
							<Input
								type="number"
								value={pin}
								onChange={(e) => validarPin(e.target.value)}
							/>
						</FormGroup>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={!cancelar ? toggle : cancelar}
					className="button-cancel"
					color="secondary"
				>
					<IntlMessage id = "dashboards.examDetails.cancel"/>
				</Button>
				<Button
					className="button-confirm"
					onClick={() => certificar()}
					disabled={!pin || pin.length !== 6 || !cpf || cpf.length !== 14}
					color="primary"
				>
					<IntlMessage id = "dashboards.examDetails.certify"/>
				</Button>
			</ModalFooter>
		</Modal>
	);
}



// WEBPACK FOOTER //
// ./src/componentes/modalCertificacao/index.jsx